import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { get } from '../../utils';
import {
  StyledSliderWrapper,
  StyledSliderTitle,
  StyledSliderButtonWrapper,
  StyledSliderContent,
  StyledEstimatorSliderButton,
  StyledOfferArrow
} from './styles';

class Slider extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    open: PropTypes.bool,
    visibleChild: PropTypes.node,
    openDispatch: PropTypes.func,
    closedDispatch: PropTypes.func,
    userOpenedMobileValue: PropTypes.bool.isRequired
  };
  static defaultProps = {
    open: true,
    className: '',
    visibleChild: '',
    openDispatch: null,
    closedDispatch: null
  };
  constructor(props) {
    super(props);
    this.state = { open: props.open };
    this.slideHandler = this.slideHandler.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.onSizeChange = this.onSizeChange.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', () => {
      if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 641) { //eslint-disable-line
        this.handleScroll();
      }
    });
    window.addEventListener('resize', () => {
      if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > 1023) {
        this.onSizeChange();
      }
    });
  }
  onSizeChange() {
    const change = this.state;
    change.open = true;
    this.setState(change);
  }
  handleScroll() {
    const { userOpenedMobileValue } = this.props;
    const change = this.state;
    if (!userOpenedMobileValue) {
      change.open = false;
      this.setState(change);
    }
  }
  slideHandler() {
    const change = this.state;
    const { openDispatch, closedDispatch } = this.props;
    change.open = !this.state.open;
    if (change.open === closed && closedDispatch) {
      closedDispatch();
    } else if (openDispatch) {
      openDispatch();
    }
    this.setState(change);
  }
  render() {
    const { children, className, visibleChild } = this.props;
    const { open } = this.state;
    const closedOpenClass = open === true ? 'open' : 'closed';
    return (
      <StyledSliderWrapper className={`estimator-slider ${closedOpenClass} ${className}`} aria-expanded={open} >
        <StyledSliderContent className="row estimator-slider-content">
          {children}
        </StyledSliderContent>
        <StyledSliderTitle className="slider-title">{visibleChild}</StyledSliderTitle>
        <StyledSliderButtonWrapper className="slider-button-wrapper">
          <StyledEstimatorSliderButton className="estimator-slider-button" onClick={this.slideHandler}>
            <StyledOfferArrow className={`offer-arrow ${closedOpenClass}`} />
          </StyledEstimatorSliderButton>
        </StyledSliderButtonWrapper>
      </StyledSliderWrapper>
    )
  }
}

const mapStateToProps = state => ({
  userOpenedMobileValue: get(state, 'userAmounts.userOpenedMobileSlider')
});

export default connect(mapStateToProps)(Slider);



/** WEBPACK FOOTER **
 ** ./src/components/Slider/index.js
 **/